import { Link } from "react-router-dom";
import { useAppContext } from "../../../libs/AppContext";
import { useTranslation } from "react-i18next";
import { BackSvg, HideSvg, SortSvg } from "../../icons";
import CustomDropMenu from "../../common/CustomDropMenu";
import Checkbox from "../../common/Checkbox";
import SearchWhite from "../../common/SearchWhite";

const DepartmentsPropertisBar = () => {
  const { t } = useTranslation();
  const {
    searchTerm,
    handleSearch,
    isAnyColumnHidden,
    visibleTableColumns,
    handleVisibleColumn,
    handleSort,
  } = useAppContext();
  const icons = {
    hide: <HideSvg />,
    sort: <SortSvg />,
  };

  return (
    <div className="w-full p-2 border-b border-black/5 bg-gray-100 flex flex-col justify-between items-center gap-2 md:flex-row md:gap-4 md:p-4">
      <div className="flex items-center justify-start gap-3 w-full">
        <Link
          to="/MainPage"
          className="border border-black/10 p-3.5 rounded flex items-center justify-center h-11 w-11"
        >
          <BackSvg />
        </Link>
        <div className="text-lg font-semibold text-gray-800 md:text-xl">
          {t("text.delegationDepartments")}
        </div>
      </div>
      <div className="w-full flex items-center justify-end gap-2 flex-row-reverse md:gap-4 md:flex-row">
        <div className="relative">
          <div className="absolute right-0">
            {isAnyColumnHidden && (
              <span className="block h-1.5 w-1.5 rounded-full bg-red-500 shadow-sm"></span>
            )}
          </div>
          <CustomDropMenu icon={icons.hide} text="Hide fields">
            {Object.entries(visibleTableColumns).map(([key, isVisible]) => (
              <div key={key} className="flex items-center gap-2">
                <Checkbox
                  checked={!isVisible}
                  onChange={() => handleVisibleColumn(key)}
                />
                {key}
              </div>
            ))}
          </CustomDropMenu>
        </div>
        <CustomDropMenu icon={icons.sort} text="Sort">
          {Object.entries(visibleTableColumns).map(([key]) => (
            <div
              key={key}
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => handleSort(key)}
            >
              <SortSvg />
              By {key}
            </div>
          ))}
        </CustomDropMenu>
        <div className="max-w-60 w-full">
          <SearchWhite searchTerm={searchTerm} handleSearch={handleSearch} />
        </div>
      </div>
    </div>
  );
};

export default DepartmentsPropertisBar;
